import Vue from "vue";
import VueRouter from "vue-router";
import { auth, checkSubscription } from "../firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "recipes" */ "../views/recipes/Recipes.vue")
  },
  {
    path: "/recipes/new",
    name: "recipe-new",
    component: () =>
      import(
        /* webpackChunkName: "recipe-new" */ "../views/recipes/RecipeNew.vue"
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/recipes/:slug",
    name: "recipe-view",
    component: () =>
      import(
        /* webpackChunkName: "recipe-view" */ "../views/recipes/RecipeView.vue"
      )
  },
  {
    path: "/recipes/:slug/edit/:tab?",
    name: "recipe-edit",
    component: () =>
      import(
        /* webpackChunkName: "recipe-edit" */ "../views/recipes/RecipeEdit.vue"
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/recipes/:page?",
    name: "recipes",
    component: () =>
      import(/* webpackChunkName: "recipes" */ "../views/recipes/Recipes.vue")
  },
  {
    path: "/tags/:page?",
    name: "tags",
    component: () =>
      import(/* webpackChunkName: "tags" */ "../views/tags/Tags.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/family",
    name: "family",
    component: () =>
      import(/* webpackChunkName: "family" */ "../views/family/Family.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/lists/:type/:id",
    name: "list-view",
    component: () =>
      import(/* webpackChunkName: "list-view" */ "../views/lists/ListView.vue"),
    meta: {
      requiresAuth: true,
      requiresSub: true
    }
  },
  {
    path: "/lists/:type?",
    name: "lists",
    component: () =>
      import(/* webpackChunkName: "lists" */ "../views/lists/Lists.vue"),
    meta: {
      requiresAuth: true,
      requiresSub: true
    }
  },
  {
    path: "/planner",
    name: "planner",
    component: () =>
      import(/* webpackChunkName: "planner" */ "../views/planner/Planner.vue"),
    meta: {
      requiresAuth: true,
      requiresSub: true
    }
  },
  {
    path: "/help/articles/:path*",
    name: "read-article",
    component: () =>
      import(/* webpackChunkName: "help" */ "../views/help/ReadArticle.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/help/tickets/new",
    name: "submit-ticket",
    component: () =>
      import(/* webpackChunkName: "help" */ "../views/help/SubmitTicket.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/help/tickets/:id",
    name: "read-ticket",
    component: () =>
      import(/* webpackChunkName: "help" */ "../views/help/ReadTicket.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/help/:page?/:path*",
    name: "help",
    component: () =>
      import(/* webpackChunkName: "help" */ "../views/help/Help.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/messages/:id",
    name: "read-message",
    component: () =>
      import(
        /* webpackChunkName: "messages" */ "../views/messages/ReadMessage.vue"
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/messages",
    name: "messages",
    component: () =>
      import(
        /* webpackChunkName: "messages" */ "../views/messages/Messages.vue"
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/account/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: "account" */ "../views/Profile.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/account/billing",
    name: "billing",
    component: () =>
      import(/* webpackChunkName: "billing" */ "../views/Billing.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/upgrade",
    name: "upgrade",
    component: () =>
      import(/* webpackChunkName: "upgrade" */ "../views/Upgrade.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/success",
    name: "upgrade-success",
    component: () =>
      import(/* webpackChunkName: "upgrade" */ "../views/UpgradeSuccess.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/signup",
    name: "signup",
    component: () =>
      import(/* webpackChunkName: "signup" */ "../views/SignUp.vue")
  },
  {
    path: "/login/:page?",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Privacy.vue")
  },
  {
    path: "/terms",
    name: "terms",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Terms.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresSub = to.matched.some(record => record.meta.requiresSub);

  console.log(to);
  auth.onAuthStateChanged(async user => {
    let authorized;
    if (user) {
      authorized = true;
    } else {
      authorized = false;
    }

    let subscribed = true;
    try {
      subscribed = await checkSubscription();
    } catch (e) {
      subscribed = false;
      console.log(e);
    }

    if (requiresAuth && !authorized && to.name !== "login") {
      next({ name: "login" });
    } else if (requiresSub && authorized && !subscribed) {
      next({ name: "upgrade" });
    } else next();
  });
});

export default router;
